// authApi.js
import axiosInstance from "./mainApi";
import { cancelAllRequests } from "./mainApi";
import store from "../store/store";
import {
  loginSuccess,
  loginFailure,
  logoutSuccess,
  logoutFailure,
  addAllUsers,
  addUser
} from "../store/actions/authStoreFunctions";
// Login
// Login
const loginApi = async (username, password, beRemembered) => {
  console.log("Login API called with:", username, password, beRemembered);
  try {
    const response = await axiosInstance.post(
      "/account/login",
      {
        username: username,
        password: password
      },
      {
        withCredentials: true
      }
    );

    console.log("Server response:", response);

    if (response.status === 200) {
      const { token, user } = response.data;
      localStorage.setItem("userToken", token);
      if (beRemembered) {
        localStorage.setItem("rememberToken", token);
      }
      store.dispatch(loginSuccess(user));
    }

    return response;
  } catch (error) {
    console.error("Error during login:");

    if (error.response) {
      console.error("Response error:", error.response);
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    } else if (error.request) {
      console.error("Request error:", error.request);
    } else {
      console.error("General error:", error.message);
    }

    store.dispatch(loginFailure(error.message));
    throw error;
  }
};

const resetPasswordApi = async ({ token, newPassword }) => {
  const response = await axiosInstance.post(
    "/account/resetPassword",
    { token, newPassword },
    { withCredentials: true }
  );
  return response; // <— visszaadjuk a teljes response-t
};
// Get All Users
const getAllUsersApi = async () => {
  try {
    const { status, data } = await axiosInstance.get("/users");
    console.log("Loading users from server response: ", data);

    if (status === 200) {
      // Másolat + rendezés user_id szerint (számként, ha string érkezik is)
      const sorted = Array.isArray(data)
        ? [...data].sort((a, b) => {
            const aId = a?.user_id ?? a?.id ?? 0;
            const bId = b?.user_id ?? b?.id ?? 0;
            const aNum = Number(aId);
            const bNum = Number(bId);
            if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) return aNum - bNum; // növekvő
            // ha nem számosítható, legyen "természetes" string rendezés
            return String(aId).localeCompare(String(bId), undefined, {
              numeric: true
            });
          })
        : data;

      store.dispatch(addAllUsers(sorted));
      return sorted;
    }

    return data;
  } catch (error) {
    console.error("Error fetching users:", error.message);
    throw error;
  }
};

const deleteUserApi = async () => {
  return;
};

// Check a token
const checkTokenApi = async (token) => {
  try {
    const response = await axiosInstance.post("/account/checkToken", {
      token
    });

    console.log("Token check response:", response);
    if (response.status === 200) {
      const { user } = response.data;
      localStorage.setItem("userToken", token);

      store.dispatch(loginSuccess(user));
    }
    return response;
  } catch (error) {
    console.error("Error during token check:", error.message);
    store.dispatch(loginFailure(error.message));
    throw error;
  }
};

const registerApi = async (registerData) => {
  const response = await axiosInstance.post("/account/register", registerData, {
    withCredentials: true
  });

  if (response.status === 200 && response.data.success) {
    const newUser = response.data.user;
    store.dispatch(addUser(newUser));
  }

  return response;
};

const forgotPasswordApi = async (email) => {
  try {
    const response = await axiosInstance.post("/account/forgotPassword", {
      email
    });
    return response.data; // szerver mindig generikus üzenetet küld
  } catch (error) {
    console.error("Error during forgot password:", error.message);
    throw error;
  }
};

const logoutApi = () => {
  try {
    cancelAllRequests(); // 🔥 minden aktív request megszakad
    store.dispatch(logoutSuccess());
    localStorage.removeItem("userToken");
    localStorage.removeItem("rememberToken");
  } catch (error) {
    console.error("Error during logout:", error.message);
    store.dispatch(logoutFailure(error.message));
    throw error;
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loginApi,
  checkTokenApi,
  logoutApi,
  getAllUsersApi,
  registerApi,
  forgotPasswordApi,
  resetPasswordApi,
  deleteUserApi
};
